/**
 * Horizon Pro — Custom Cursor
 * Replaces default cursor with a dot, ring, or dot+ring that follows the mouse.
 * Ring scales up on interactive element hover. Disabled on touch devices and prefers-reduced-motion.
 * Automatically hides when dialogs (cart drawer, etc.) are open so native cursor + pointer works.
 */
(function () {
  const cursor = document.querySelector('.hp-cursor');
  if (!cursor) return;

  // Bail on touch devices or reduced motion
  if (window.matchMedia('(pointer: coarse)').matches) {
    cursor.remove();
    return;
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    cursor.remove();
    document.documentElement.style.cursor = '';
    return;
  }

  const dot = cursor.querySelector('.hp-cursor__dot');
  const ring = cursor.querySelector('.hp-cursor__ring');

  let mouseX = -100, mouseY = -100;
  let ringX = -100, ringY = -100;
  const lerp = 0.15;
  let rafId;
  let dialogOpen = false;

  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (dot && !dialogOpen) {
      dot.style.transform = 'translate(calc(' + mouseX + 'px - 50%), calc(' + mouseY + 'px - 50%))';
    }
  }, { passive: true });

  if (ring) {
    function animateRing() {
      if (!dialogOpen) {
        var dx = mouseX - ringX;
        var dy = mouseY - ringY;
        if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) {
          ringX = mouseX;
          ringY = mouseY;
        } else {
          ringX += dx * lerp;
          ringY += dy * lerp;
        }
        ring.style.transform = 'translate(calc(' + ringX + 'px - 50%), calc(' + ringY + 'px - 50%))';
      }
      rafId = requestAnimationFrame(animateRing);
    }
    rafId = requestAnimationFrame(animateRing);
  }

  // Scale ring on interactive hover
  document.addEventListener('mouseover', function (e) {
    if (dialogOpen) return;
    const target = e.target.closest('a, button, [role="button"], input, select, textarea, label, [data-cursor-hover]');
    if (target && ring) {
      ring.classList.add('hp-cursor__ring--hover');
    }
  }, { passive: true });

  document.addEventListener('mouseout', function (e) {
    if (dialogOpen) return;
    const target = e.target.closest('a, button, [role="button"], input, select, textarea, label, [data-cursor-hover]');
    if (target && ring) {
      ring.classList.remove('hp-cursor__ring--hover');
    }
  }, { passive: true });

  // Hide when mouse leaves window
  document.addEventListener('mouseleave', function () {
    cursor.style.opacity = '0';
  });
  document.addEventListener('mouseenter', function () {
    if (!dialogOpen) cursor.style.opacity = '1';
  });

  /* ---- Dialog awareness: hide custom cursor when any dialog is open ---- */
  var dialogStyleEl = null;

  function hideCustomCursor() {
    dialogOpen = true;
    cursor.style.opacity = '0';
    cursor.style.pointerEvents = 'none';
    /* Inject a style that restores native cursors on the open dialog */
    if (!dialogStyleEl) {
      dialogStyleEl = document.createElement('style');
      dialogStyleEl.textContent =
        'dialog[open], dialog[open] *, ' +
        'dialog[open] a, dialog[open] button, dialog[open] [role="button"], ' +
        'dialog[open] input, dialog[open] select, dialog[open] textarea, dialog[open] label ' +
        '{ cursor: auto !important; }' +
        'dialog[open] a, dialog[open] button, dialog[open] [role="button"], dialog[open] label, ' +
        'dialog[open] summary, dialog[open] [data-cursor-hover] ' +
        '{ cursor: pointer !important; }' +
        'dialog[open] input[type="text"], dialog[open] input[type="email"], ' +
        'dialog[open] input[type="search"], dialog[open] input[type="number"], ' +
        'dialog[open] textarea { cursor: text !important; }';
      document.head.appendChild(dialogStyleEl);
    }
  }

  function showCustomCursor() {
    dialogOpen = false;
    cursor.style.opacity = '1';
    cursor.style.pointerEvents = '';
    if (dialogStyleEl) {
      dialogStyleEl.remove();
      dialogStyleEl = null;
    }
  }

  /* Listen for Horizon's dialog open/close custom events */
  document.addEventListener('dialog:open', hideCustomCursor);
  document.addEventListener('dialog:after-close', showCustomCursor);

  /* Fallback: MutationObserver on any <dialog> open attribute changes */
  var dialogObserver = new MutationObserver(function (mutations) {
    var anyOpen = document.querySelector('dialog[open]');
    if (anyOpen && !dialogOpen) hideCustomCursor();
    else if (!anyOpen && dialogOpen) showCustomCursor();
  });

  /* Observe all dialogs in the DOM (current + future) */
  function observeDialogs() {
    document.querySelectorAll('dialog').forEach(function (d) {
      dialogObserver.observe(d, { attributes: true, attributeFilter: ['open'] });
    });
  }
  observeDialogs();

  /* Re-observe when new dialogs are added to the DOM */
  new MutationObserver(function () { observeDialogs(); })
    .observe(document.body, { childList: true, subtree: true });
})();
